var counter = 0;
export default (function () { return --counter; });
